
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fzbVm", function(module, exports) {
$parcel$export(module.exports, "FooterCreateButtons", () => (parcelRequire("cEHmK")).FooterCreateButtons);

var $cEHmK = parcelRequire("cEHmK");


});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<bb240b22e09d0e349cbdc3cc16e0e4d3>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("ix5ga", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jb2R2 = parcelRequire("jb2R2");


var $6mKj3 = parcelRequire("6mKj3");


var $JCGnt = parcelRequire("JCGnt");


var $kOUwv = parcelRequire("kOUwv");

const $445a10c348ba0003$var$FIRST_THIRTY_DAYS_THRESHOLD = 30;
const $445a10c348ba0003$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
const $445a10c348ba0003$var$AUTO_PROVISIONED_TRAIT = 'is_jira_confluence_d0_auto-provisioned';
const $445a10c348ba0003$export$c707d9e60ebc257c = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: skip } = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            activeDaysThreshold: $445a10c348ba0003$var$FIRST_THIRTY_DAYS_THRESHOLD
        };
        $[2] = t2;
    } else t2 = $[2];
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)(t2, Boolean(skip));
    const { data: siteTraitsData, loading: isSiteTraitsLoading } = (0, $kOUwv.useSiteTraits)();
    const siteActivationDate = siteTraitsData?.attributes?.find($445a10c348ba0003$var$_temp)?.value;
    const isSiteNewlyActivated = Boolean(siteActivationDate) && (0, $jb2R2.default)(new Date(), new Date(siteActivationDate)) < $445a10c348ba0003$var$FIRST_THIRTY_DAYS_THRESHOLD;
    const isAutoProvisioned = siteTraitsData?.attributes?.find($445a10c348ba0003$var$_temp2)?.value === "true";
    if (skip) {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                isEnabled: false,
                loading: false
            };
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    if (isNewUserLoading || isSiteTraitsLoading) {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                isEnabled: false,
                loading: true
            };
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    const isWithinFirstThirtyDays = isAutoProvisioned ? isNewUser : isSiteNewlyActivated;
    if (!isWithinFirstThirtyDays) {
        let t3;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                isEnabled: false,
                loading: false
            };
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            isEnabled: (0, $6mKj3.expVal)("twcg-2304-import-in-onboarding", "isEnabled", false),
            loading: false
        };
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
function $445a10c348ba0003$var$_temp(t0) {
    const { name: name } = t0;
    return name === $445a10c348ba0003$var$FIRST_ACTIVATION_DATE_TRAIT;
}
function $445a10c348ba0003$var$_temp2(t0) {
    const { name: name_0 } = t0;
    return name_0 === $445a10c348ba0003$var$AUTO_PROVISIONED_TRAIT;
}
module.exports["useTwcg2304ImportInOnboarding"] = $445a10c348ba0003$export$c707d9e60ebc257c;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("fs4H1", function(module, exports) {

let $b3fd1c769f71fe97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3fd1c769f71fe97$var$load("zUKwV"),
    $b3fd1c769f71fe97$var$load("fUeur"),
    $b3fd1c769f71fe97$var$load("72q0k"),
    $b3fd1c769f71fe97$var$load("hhss7"),
    $b3fd1c769f71fe97$var$load("e4KJa")
]).then(()=>parcelRequire('i2kPA'));

});

parcelRegister("9ffq8", function(module, exports) {

let $6bb179f65d05a4aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6bb179f65d05a4aa$var$load("6wr18"),
    $6bb179f65d05a4aa$var$load("llcQo"),
    $6bb179f65d05a4aa$var$load("7EorR"),
    $6bb179f65d05a4aa$var$load("ffEVr"),
    $6bb179f65d05a4aa$var$load("hhss7"),
    $6bb179f65d05a4aa$var$load("67Pvd")
]).then(()=>parcelRequire('6IU81'));

});

parcelRegister("9conO", function(module, exports) {

let $6b28260498c5bdad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b28260498c5bdad$var$load("d1QkY").then(()=>parcelRequire('hydSe'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("cEHmK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2fQCH = parcelRequire("2fQCH");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $b3j2Y = parcelRequire("b3j2Y");


var $jmjWc = parcelRequire("jmjWc");


var $kDja4 = parcelRequire("kDja4");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $yuLaV = parcelRequire("yuLaV");





var $hekY6 = parcelRequire("hekY6");





var $kSwu1 = parcelRequire("kSwu1");


var $bh4C9 = parcelRequire("bh4C9");


var $ad7Ou = parcelRequire("ad7Ou");


var $9KSWX = parcelRequire("9KSWX");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");




var $722ac9d1540b1bd9$exports = {};
$722ac9d1540b1bd9$exports = new URL("word.87639ee0.svg", import.meta.url).toString();


var $74a9dd7c6fa9a2e1$exports = {};
$74a9dd7c6fa9a2e1$exports = new URL("googleDocs.076e85b0.svg", import.meta.url).toString();


var $ea883c95aa5337f3$exports = {};
$ea883c95aa5337f3$exports = new URL("oneDriveLogo.a603c61e.svg", import.meta.url).toString();



var $9wGTI = parcelRequire("9wGTI");


var $ix5ga = parcelRequire("ix5ga");

const $b2eae9839b52c3e5$var$FEDRAMP_HOSTNAMES = new Set([
    'atlassian-fex.com',
    'atlassian-fex.net',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net',
    'atlassian-stg-fedm.net'
]);
const $b2eae9839b52c3e5$var$isFedRampEnv = ()=>{
    if (!(0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) return false;
    const hostname = window?.location?.hostname || '';
    const environmentTail = hostname.split('.').slice(-2).join('.');
    return $b2eae9839b52c3e5$var$FEDRAMP_HOSTNAMES.has(environmentTail);
};
const $b2eae9839b52c3e5$var$i18n = (0, $kSwu1.defineMessages)({
    importLabel: {
        id: "experiment-twcg-2304-import-in-onboarding.import-cta.label",
        defaultMessage: "Import"
    },
    importLozenge: {
        id: "experiment-twcg-2304-import-in-onboarding.import-cta.lozenge",
        defaultMessage: "TRY"
    },
    microsoftWordLabel: {
        id: "experiment-twcg-2304-import-in-onboarding.import-cta.source.word",
        defaultMessage: "Microsoft Word"
    },
    googleDocsLabel: {
        id: "experiment-twcg-2304-import-in-onboarding.import-cta.source.gdoc",
        defaultMessage: "Google Docs"
    },
    oneDriveLabel: {
        id: "experiment-twcg-2304-import-in-onboarding.import-cta.source.onedrive",
        defaultMessage: "OneDrive"
    }
});
const $b2eae9839b52c3e5$var$sourceIconStyles = null;
const $b2eae9839b52c3e5$var$dropdownItemGroupStyles = null;
const $b2eae9839b52c3e5$var$titleWrapperStyles = null;
const $b2eae9839b52c3e5$var$buttonWrapperStyles = null; /**
                                   * "Import" CTA rendered in the space side navigation for new users.
                                   *
                                   * This component is 100% gated behind the twcg-2304-import-in-onboarding experiment.
                                   * It renders nothing when:
                                   * - The experiment is loading
                                   * - The experiment is off (control arm)
                                   * - The user is not eligible (not founding admin, or outside first 30 days)
                                   *
                                   * Clicking the button opens a dropdown with three import source options:
                                   * Microsoft Word, Google Docs, and OneDrive. Selecting a source calls
                                   * `onSelectSource` with the corresponding source key.
                                   *
                                   * Styled to match the TreeCreateContentButton ("+ Create" button) in the page tree.
                                   */ 
const $b2eae9839b52c3e5$export$7f7943e356dfc572 = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { onSelectSource: onSelectSource } = t0;
    const { isEnabled: isEnabled, loading: loading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = $b2eae9839b52c3e5$var$isFedRampEnv();
        $[0] = t1;
    } else t1 = $[0];
    const isFedRamp = t1;
    if (loading || !isEnabled) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0jFU0VnlTt _2XsHFMPgdg _0hPCNLDIqT _3iDTPbQ4SZ _3syKoKdnbC _2h7MEPJg58 _3tOQhEdnbC _04h2sEJg58 _2dvbuWDIqT"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== createAnalyticsEvent) {
        t3 = (t4)=>{
            const { isOpen: isOpen } = t4;
            if (!isOpen) return;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    source: "twcg-2304-import-in-onboarding-import-button"
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== intl) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, onClick: onClick, ...triggerProps } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                onClick: onClick,
                testId: "import-onboarding-cta",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))),
                appearance: "subtle",
                shouldFitContainer: true,
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzZpcK _1kk5Tkf7mX _2XsHFM1Y8M"
                ])
            }, intl.formatMessage($b2eae9839b52c3e5$var$i18n.importLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "new",
                isBold: true
            }, intl.formatMessage($b2eae9839b52c3e5$var$i18n.importLozenge))));
        };
        $[4] = intl;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_4ouGXIscCB"
        ]);
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== onSelectSource) {
        t6 = ()=>onSelectSource("wordDoc");
        $[7] = onSelectSource;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($722ac9d1540b1bd9$exports))),
            alt: "",
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_39xV02ey7F _0jFU0Vey7F _00EA0egIor _3iDTPbvLZJ"
            ])
        });
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== intl) {
        t8 = intl.formatMessage($b2eae9839b52c3e5$var$i18n.microsoftWordLabel);
        $[10] = intl;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: "import-onboarding-cta-word",
            onClick: t6,
            elemBefore: t7
        }, t8);
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== intl || $[17] !== onSelectSource) {
        t10 = !isFedRamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: "import-onboarding-cta-gdoc",
            onClick: ()=>onSelectSource("gDoc"),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($74a9dd7c6fa9a2e1$exports))),
                alt: "",
                "aria-hidden": true,
                className: (0, $hekY6.default)([
                    "_39xV02ey7F _0jFU0Vey7F _00EA0egIor _3iDTPbvLZJ"
                ])
            })
        }, intl.formatMessage($b2eae9839b52c3e5$var$i18n.googleDocsLabel));
        $[16] = intl;
        $[17] = onSelectSource;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== intl || $[20] !== onSelectSource) {
        t11 = !isFedRamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: "import-onboarding-cta-onedrive",
            onClick: ()=>onSelectSource("office365Doc"),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ea883c95aa5337f3$exports))),
                alt: "",
                "aria-hidden": true,
                className: (0, $hekY6.default)([
                    "_39xV02ey7F _0jFU0Vey7F _00EA0egIor _3iDTPbvLZJ"
                ])
            })
        }, intl.formatMessage($b2eae9839b52c3e5$var$i18n.oneDriveLabel));
        $[19] = intl;
        $[20] = onSelectSource;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t10 || $[23] !== t11 || $[24] !== t5 || $[25] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
            className: t5
        }, t9, t10, t11);
        $[22] = t10;
        $[23] = t11;
        $[24] = t5;
        $[25] = t9;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== t12 || $[28] !== t3 || $[29] !== t4) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-start",
            onOpenChange: t3,
            trigger: t4
        }, t12);
        $[27] = t12;
        $[28] = t3;
        $[29] = t4;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== t13 || $[32] !== t2) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, t13);
        $[31] = t13;
        $[32] = t2;
        $[33] = t14;
    } else t14 = $[33];
    return t14;
};






const $658edb555a8ec380$export$860d6e498aef4be5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "oH28a",
    name: "OnboardingImportLauncher",
    loader: async ()=>(await (parcelRequire("fs4H1"))).OnboardingImportLauncher
});


const $774b2680aae17aaf$var$FooterCreateButtonsQuery = (0, $2fQCH.default);

const $774b2680aae17aaf$var$ContentTreeOnboardingLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "45vJD",
    name: "ContentTreeOnboardingLoader",
    loader: async ()=>(await (parcelRequire("9ffq8"))).ContentTreeOnboarding
});

const $774b2680aae17aaf$var$TreeBottomCreateButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wssRG",
    name: "TreeBottomCreateButtonLoader",
    loader: async ()=>(await (parcelRequire("9conO"))).TreeBottomCreateButton
});
const $774b2680aae17aaf$export$ab00dd23925d8af0 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { spaceKey: spaceKey, isContentTreeLoading: isContentTreeLoading, emptyContent: emptyContent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database");
        $[0] = t1;
    } else t1 = $[0];
    const isDatabasesGloballyEnabled = t1;
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== createAnalyticsEvent) {
        t2 = (source)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: source,
                    source: "twcg-2304-import-in-onboarding-import-button",
                    attributes: {
                        importSource: source
                    }
                }
            }).fire();
        };
        $[1] = createAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const fireImportCTAAnalytics = t2;
    let t3;
    if ($[3] !== spaceKey) {
        t3 = {
            errorPolicy: "all",
            variables: {
                spaceKey: spaceKey
            }
        };
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($774b2680aae17aaf$var$FooterCreateButtonsQuery, {
        ...t3,
        __callerPackage__: "create-blank-fabric-page"
    });
    if (isContentTreeLoading || loading || !data) return null;
    const canCreatePage = (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: "page"
    });
    if (!canCreatePage) {
        let t4;
        if ($[5] !== emptyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, emptyContent);
            $[5] = emptyContent;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const didContainUserContent = data?.space?.didContainUserContent;
    const showContentTreeOnboarding = didContainUserContent === false;
    const showLiveDoc = Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    let t4;
    if ($[7] !== data?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled || $[8] !== isWhiteboardFeatureEnabled) {
        t4 = isWhiteboardFeatureEnabled("whiteboardsEnabled") && Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
        $[7] = data?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled;
        $[8] = isWhiteboardFeatureEnabled;
        $[9] = t4;
    } else t4 = $[9];
    const showWhiteboard = t4;
    const showDatabase = isDatabasesGloballyEnabled && Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    let t5;
    if ($[10] !== emptyContent || $[11] !== fireImportCTAAnalytics || $[12] !== showContentTreeOnboarding || $[13] !== showDatabase || $[14] !== showLiveDoc || $[15] !== showWhiteboard || $[16] !== spaceKey) {
        t5 = showContentTreeOnboarding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($774b2680aae17aaf$var$ContentTreeOnboardingLoader, {
            showLiveDoc: showLiveDoc,
            showWhiteboard: showWhiteboard,
            showDatabase: showDatabase
        }) : emptyContent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($774b2680aae17aaf$var$TreeBottomCreateButtonLoader, {
            spaceKey: spaceKey,
            source: "endOfContentTreeContextualCreate"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $658edb555a8ec380$export$860d6e498aef4be5), {
            spaceKey: spaceKey
        }, (t6)=>{
            const { startImport: startImport } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2eae9839b52c3e5$export$7f7943e356dfc572), {
                onSelectSource: (source_0)=>{
                    fireImportCTAAnalytics(source_0);
                    startImport(source_0);
                }
            });
        }));
        $[10] = emptyContent;
        $[11] = fireImportCTAAnalytics;
        $[12] = showContentTreeOnboarding;
        $[13] = showDatabase;
        $[14] = showLiveDoc;
        $[15] = showWhiteboard;
        $[16] = spaceKey;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== error) {
        t6 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[18] = error;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6);
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
};
module.exports["FooterCreateButtons"] = $774b2680aae17aaf$export$ab00dd23925d8af0;

});


//# sourceMappingURL=FooterCreateButtons.489b13cb.js.map
